<div
  [class.text-proffeo-muted]="isPlaceholder()"
  [class.font-bold]="textBold()"
  class="flex gap-1"
>
  <span class="truncate">
    <ng-content></ng-content>
  </span>
  @if (required()) {
    <span class="text-lg text-proffeo-danger">*</span>
  }
</div>
